import React from "react";
import ReactDom from "react-dom";
import { Paper } from "material-ui";

export default class ResizableMenu extends React.Component {
  componentDidMount() {
    // reimplementation of old LeftNav height change
    this.onResize = () => {
      let menu = ReactDom.findDOMNode(this._menu);
      let container = menu.parentNode;
      let menuHeight = container.clientHeight - menu.offsetTop;
      menu.style.height = menuHeight + "px";
    };

    this.onResize();

    window.addEventListener("resize", this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  render() {
    return (
      <Paper
        ref={p => (this._menu = p)}
        transitionEnabled={true}
        zDepth={0}
        style={this.props.style}
      >
        {this.props.children}
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/partials/resizable-menu.jsx